module.exports = __webpack_public_path__ + "img/module2_item2.755075f2.png";